<script>
import {h} from 'vue';
import ArticleAboutUs from '@/components/article/ArticleAboutUs.vue';
import ArticleContact from '@/components/article/ArticleContact.vue';
import ArticleHome from '@/components/article/ArticleHome.vue';
import ArticleNativeSpeakers from '@/components/article/ArticleNativeSpeakers.vue';
import ArticleProjectManagement from '@/components/article/ArticleProjectManagement.vue';
import ArticleSeoWork from '@/components/article/ArticleSeoWork.vue';
import ArticleTerms from '@/components/article/ArticleTerms.vue';
import ArticleWhyUs from '@/components/article/ArticleWhyUs.vue';

export default {
    // https://stackoverflow.com/questions/70957780/how-i-can-render-a-component-from-a-string-with-vue-3
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render() {
        const r = {
            components: {
                ArticleAboutUs,
                ArticleContact,
                ArticleHome,
                ArticleNativeSpeakers,
                ArticleProjectManagement,
                ArticleSeoWork,
                ArticleTerms,
                ArticleWhyUs,
            },
            template: `
                <div class="content-compiled">${this.html || ''}</div>`,
            /**
            methods: {
                hello () {
                    // method "hello" is also available here
                },
            },
            **/
        };
        return h(r);
    },
};
</script>
